import * as A from '../admin'
import {blockMeta} from '../meta'

export interface ImageBlockConfig extends A.BlockConfig {
  altText: string
  imageUrl: string
  linkUrl: string
  tizraId: string
  coverId: string
  width: 'bleed' | 'contain'
  maxWidth: string
  maxHeight: string
  fitting: 'contain' | 'cover' | 'scale-down'
  position: A.Justification
  focus: A.CompassDirection
  surround: 'none' | 'padding' | 'shadow'
}

const defaultConfig: ImageBlockConfig = {
  altText: '',
  imageUrl: '',
  linkUrl: '',
  tizraId: '',
  coverId: '',
  width: 'bleed',
  maxWidth: '',
  maxHeight: '',
  fitting: 'contain',
  position: 'left',
  focus: '',
  surround: 'none',
  FREEMARKER: {
    altText: 'text',
    imageUrl: 'text',
  },
}

export const meta = blockMeta({
  name: 'image',
  displayName: 'ImageBlock',
  title: 'Image',
  defaultConfig,
})
